import { Subscription } from 'rxjs/Subscription';
import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

export function compareValidator(controlNameToCompare: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control.value === null || control.value.length === 0) {
            return null;
        }

        const controlToCompare = control.root.get(controlNameToCompare);
        if (controlToCompare) {
            const subscription: Subscription = controlToCompare.valueChanges.subscribe(() => {
                control.updateValueAndValidity();
                subscription.unsubscribe();
            })
        }

        return controlToCompare && controlToCompare.value !== control.value ? { 'compare': true } : null;
    }
}



// WEBPACK FOOTER //
// ./src/app/_common/validation/compare.validator.ts